import style from "../style/Info.module.scss";
import className from "classnames/bind";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {apiError, handleRequest} from "../../../utils";
import {userApi} from "../../../api";
import {Image, StatusLabel} from "../../../components";
const cn = className.bind(style);
function Info() {

	const {username, token} = useParams();

	const [user, setUser] = useState({});
	
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		loadUser().then();
	}, [username, token])
	
	const loadUser = async () => {
		setLoading(true);
		let [error, response] = await handleRequest(userApi.info({
			username, token
		}));
		let message = apiError(`Lấy thông tin báo cáo thất bại`, error, response);
		if (!message) {
			setUser(response.data)
		}
		setLoading(false);
	}

	// Dữ liệu chi tiết cho từng chức vụ
	const roleDetails = {
		"design": [
			{ title: "Sáng tạo", des: "Tạo ra thiết kế độc đáo, truyền tải thông điệp thương hiệu." },
			{ title: "Mỹ thuật", des: "Cân bằng giữa thẩm mỹ và tính ứng dụng trong sản phẩm." },
			{ title: "Chi tiết", des: "Chú trọng từng đường nét để sản phẩm hoàn hảo nhất." },
			{ title: "Cập nhật xu hướng", des: "Nắm bắt nhanh các xu hướng thiết kế hiện đại." }
		],
		"technical": [
			{ title: "Chính xác", des: "Đảm bảo hệ thống vận hành ổn định và bảo mật." },
			{ title: "Giải pháp", des: "Luôn tìm cách tối ưu hiệu suất và xử lý vấn đề phức tạp." },
			{ title: "Bảo mật", des: "Đặt an toàn dữ liệu và hệ thống lên hàng đầu." },
			{ title: "Đổi mới", des: "Luôn áp dụng công nghệ mới để nâng cao chất lượng." }
		],
		"sales": [
			{ title: "Chiến lược", des: "Xây dựng kế hoạch kinh doanh hiệu quả." },
			{ title: "Khách hàng", des: "Luôn lắng nghe và mang lại giải pháp phù hợp." },
			{ title: "Đàm phán", des: "Tạo ra cơ hội hợp tác đôi bên cùng có lợi." },
			{ title: "Phát triển thị trường", des: "Mở rộng thị phần và khẳng định thương hiệu." }
		],
		"personnel": [
			{ title: "Kết nối", des: "Tạo ra môi trường làm việc gắn kết và bền vững." },
			{ title: "Đào tạo", des: "Giúp nhân viên phát triển năng lực và sự nghiệp." },
			{ title: "Công bằng", des: "Đảm bảo sự công bằng trong đánh giá và đãi ngộ." },
			{ title: "Văn hóa", des: "Xây dựng môi trường làm việc tích cực và nhân văn." }
		],
		"accounting": [
			{ title: "Minh bạch", des: "Quản lý tài chính chính xác và rõ ràng." },
			{ title: "Kiểm soát", des: "Đảm bảo nguồn vốn được sử dụng hợp lý và hiệu quả." },
			{ title: "Báo cáo", des: "Thực hiện báo cáo tài chính nhanh chóng và chính xác." },
			{ title: "Tuân thủ", des: "Đảm bảo tuân thủ quy định pháp luật và chuẩn mực kế toán." }
		],
		"customerService": [
			{ title: "Thấu hiểu", des: "Luôn lắng nghe nhu cầu và phản hồi kịp thời cho khách hàng." },
			{ title: "Tận tâm", des: "Mang lại trải nghiệm dịch vụ tốt nhất, tạo niềm tin lâu dài." },
			{ title: "Nhanh chóng", des: "Giải quyết thắc mắc, sự cố trong thời gian ngắn nhất." },
			{ title: "Thân thiện", des: "Xây dựng mối quan hệ thân thiết, gần gũi với khách hàng." }
		],
		"marketing": [
			{ title: "Sáng tạo", des: "Xây dựng các chiến dịch truyền thông độc đáo và hiệu quả." },
			{ title: "Định hướng", des: "Phân tích thị trường và đưa ra chiến lược phát triển thương hiệu." },
			{ title: "Tối ưu", des: "Theo dõi dữ liệu và tối ưu hiệu quả quảng cáo." },
			{ title: "Lan tỏa", des: "Đưa thương hiệu đến gần hơn với khách hàng." }
		]
	};

	// Các đặc điểm chung cho mọi thành viên
	const defaultDetails = [
		{
			title: "Sáng tạo",
			des: "Là “chìa khóa” cốt lõi tạo ra những sản phẩm website hoàn hảo và hiệu quả."
		},
		{
			title: "Sức trẻ",
			des: "Nội lực đặc biệt giúp chinh phục mọi thử thách."
		},
		{
			title: "Sự chuyên nghiệp",
			des: "Thể hiện từ những chi tiết nhỏ nhất, trong công việc và tiếp xúc khách hàng."
		},
		{
			title: "Đam mê",
			des: "Chính là khởi nguồn tạo ra Sikido và ngọn lửa đam mê này sẽ duy trì mãi mãi."
		}
	];

	const finalDetails = roleDetails[user?.role?.key] || defaultDetails;

	return (
		<>
			<div className={cn("user-information")}>
				<div className={cn("container")}>
					<div className={cn("user-information-header")}>
						<div className={cn("user-header-content")}>
							<p className={cn("txt-hello")}>Xin chào, tôi là</p>
							<p className={cn("txt-name")}>{user?.firstname} <strong>{user?.lastname}</strong>
							</p>
							<p className={cn("txt-office")}>{user?.role?.label}</p>
							<div className={cn("item-list")}>
								{finalDetails.map((item, idx) => (
									<div key={idx} className={cn("item")}>
										<div className={cn("img")}></div>
										<div className={cn("title")}>{item.title}</div>
										<div className={cn("des")}>{item.des}</div>
									</div>
								))}
							</div>
						</div>
						<div className={cn("user-header-avatar")}>
							<div className={cn("user-avatar-border")}>
								<div className={cn("circle")}><Image src={"https://sikido.vn/uploads/source/header/logo-(1).png"} /></div>
								<div className={cn("user-img")}>
									<Image src={user?.avatar} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className={cn("user-information-content")}>
				<div className={cn("user-content")}>
					<p className={cn("txt-company text-center")}>CÔNG TY TNHH</p>
					<p className={cn("txt-company-name text-center")}>SKD GROUP</p>
					<div className={cn("info")}>
						<div className={cn("info-title")}>MSNV:</div>
						<div className={cn("info-content")}>{user?.username}</div>
					</div>
					<div className={cn("info")}>
						<div className={cn("info-title")}>PHONE:</div>
						<div className={cn("info-content")}>{user?.phone}</div>
					</div>
					<div className={cn("info")}>
						<div className={cn("info-title")}>EMAIL:</div>
						<div className={cn("info-content")}>{user?.email}</div>
					</div>
					<div className={cn("info")}>
						<div className={cn("info-title")}>ĐỊA CHỈ:</div>
						<div className={cn("info-content")}>36 Đường D5 - Phường Thạnh Mỹ Tây - TP Hồ Chí Minh</div>
					</div>
					<div className={cn("info")}>
						<div className={cn("info-title")}>PHÒNG BAN:</div>
						<div className={cn("info-content")}><StatusLabel type={user?.role?.badge}>{user?.department?.label}</StatusLabel></div>
					</div>
				</div>
			</div>
			<div className={cn("header")}>
				<div>
					<svg className={cn("waves")} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
						<defs>
							<path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"/>
						</defs>
						<g className={cn("parallax")}>
							<use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7)"/>
							<use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)"/>
							<use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)"/>
							<use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff"/>
						</g>
					</svg>
				</div>
			</div>
		</>
	)
}

export default Info;